module.exports = __webpack_public_path__ + "img/gamechar_thumb.c2e73c4d.jpg";